import { useEffect, useRef, useState } from "react"
import React from "react"
import useVars from "./Stores/useVars.jsx"
import { addEffect } from "@react-three/fiber"

export default function Interface() {

    const moneyRef = useRef()
    const time = useRef()
    const buyMenu = useRef()
    const plotsNum = useRef()

    const popNum = useRef()
    const victoryPointNum = useRef()
    const salaryRef = useRef()

    const progressionRef = useRef()
    const gameOverRef = useRef()
    const finalScoreRef = useRef()

    const phase = useVars().phase
    const varsState = useVars()
    const [cardsViewable, setCardsViewable] = useState([false,false,false,false,false,false,false,false,false,false,false,false])

    const audioRef = useRef()
    let elapsedTime = 0

    if(buyMenu.current && phase == 'buying')
    {
        buyMenu.current.style.right = "0px"
    }
    else if(buyMenu.current && phase == 'scrolling')
    {
        buyMenu.current.style.right = "-480px"
    }

    useEffect(() =>
    {
        const unsubscribePhase = useVars.subscribe(
            (state) => state.phase,
            (value) =>
            {
                if(value == 'gameOver')
                {
                    // console.log(varsState.victoryPoints)
                    time.current.textContent = "0:00"
                    // finalScoreRef.current.textContent = varsState.victoryPoints
                    gameOverRef.current.style.display = 'flex'
                }
            }
        )
        const unsubscribeVictoryPoints = useVars.subscribe(
            (state) => state.victoryPoints,
            (value) =>
            {
                victoryPointNum.current.textContent = value
                finalScoreRef.current.textContent = value
            }
        )
        const unsubscribeSalary = useVars.subscribe(
            (state) => state.salary,
            (value) =>
            {
                salaryRef.current.textContent = value
                // console.log(value)
            }
        )
        const unsubscribePopulation = useVars.subscribe(
            (state) => state.population,
            (value) =>
            {
                popNum.current.textContent = value
                // console.log(value)
            }
        )
        const unsubscribeAudioEnabled = useVars.subscribe(
            (state) => state.audioEnabled,
            (value) =>
            {
                // musicTrack.volume = 0
                // console.log(musicTrack.volume)
            }
        )

        
        const unsubscribeEffect = addEffect(() =>
        {
            const state = useVars.getState()
            // console.log(state.salary)
            if(moneyRef.current)
                moneyRef.current.textContent = state.money
            if(plotsNum.current)
                plotsNum.current.textContent = state.plots
            
            

            /*
            TIME & CLOCK
            */
            
            if(state.phase == 'scrolling' || state.phase == 'buying')
                elapsedTime = Date.now() - state.startTime
            elapsedTime = elapsedTime / 1000
            let clockTime = (120 - elapsedTime).toFixed()
            if(time.current)
            {
                const timeDisplay = Math.trunc(clockTime / 60) + " : " + (clockTime % 60 < 10 ? '0' : '') + (clockTime % 60).toFixed()
                time.current.textContent = timeDisplay
            }

            if(elapsedTime > 120)
            {
                
                varsState.endGame()
            }
            if(moneyRef.current)
            progressionRef.current.style.width = ((elapsedTime * 33.333) % 100) + "%"
        })

        

        return () =>
        {
            unsubscribeEffect()
            unsubscribePhase()
            unsubscribeSalary()
            unsubscribeVictoryPoints()
            unsubscribePopulation()
            unsubscribeAudioEnabled()
        }
    }, [])

    function HideInterface() {
        let instructions = document.getElementById('instructions')
        audioRef.current.volume = .2
        audioRef.current.play()

        instructions.style.display = "none";
        varsState.renderGame()
    }

    function ToggleAudio() {
        // console.log(varsState.audioEnabled)
        if(varsState.audioEnabled)
        {
            audioRef.current.volume = 0
            // console.log(musicTrack.volume)
            varsState.toggleAudio(false)
        }
        else
        {
            audioRef.current.volume = 0.2
            varsState.toggleAudio(true)
        }
    }

    return varsState.phase != 'ready' ? <div className="interface">
        <audio ref={audioRef} src="audio/00-music.mp3"></audio>

        {/* INSTRUCTIONS PANEL */}
        <div className="instructions-holder" id="instructions">
            <div className="instructions-panel">
                <div className="title">
                    Start Timer?
                </div>
                <div className="body-text">
                    
                </div>
                <div className="button-holder" >
                    <button onClick={HideInterface}>Ready!</button>
                </div>
            </div>
        </div>

        {/* GAME OVER UI */}
        <div ref={gameOverRef} className="game-over">
            <div className="game-over-modal">
                <div className="title">Time's Up!</div>
                <div className="body">
                    Congratulations, you achieved a score of 
                    <div ref={finalScoreRef} className="high-score">{varsState.victoryPoints}</div>
                </div>
                <button className="play-again" onClick={() => {location.reload()}}>Play Again</button>
            </div>
        </div>

        {/* TOP BAR */}
        <div className="top-bar">
            <div className="left-stats">
                <div className="stat">
                    <img src='icons/03-population.svg'/>
                    <div className="stat-text" ref={popNum} style={{color: '#C8791D'}}>0</div>
                </div>
                <div className="stat">
                    <img src='icons/02-buildings.svg'/>
                    <div className="stat-text" ref={plotsNum} style={{color: '#3B7AA8'}}></div>
                </div>
                <div className="stat">
                    <img src='icons/04-victory-points.svg'/>
                    <div className="stat-text" ref={victoryPointNum} style={{color: '#6C26C6'}}>0</div>
                </div>
                <div className="stat">
                    <img src='icons/05-time.svg'/>
                    <div className="stat-text" ref={time} style={{color: '#A01717'}}></div>
                </div>
            </div>
            <div className="middle-stats">
                <div className="stat">
                    <img src='icons/01-money.svg' style={{width: '32px'}}/>
                    <div className="stat-text" ref={moneyRef} style={{color: '#0E8E0B', fontSize: '24px'}}>10</div>
                </div>
                <div className="interval-bar">
                    <div className="salary">
                        +$
                        <div className="salaryNum"ref={salaryRef}>5</div>
                    </div>
                    <img src="icons/16-salary.svg" style={{position: "absolute", padding: "4px", width: "20px"}}/>
                    <div className="progression" ref={progressionRef}>
                    </div>
                </div>
            </div>
            
        </div>
        <div className="audio-toggle" onClick={ToggleAudio} >
            Sound: {varsState.audioEnabled ? 'On' : 'Off' }
            {varsState.audioEnabled ? <img src="icons/19-volume-on.svg" /> : <img src="icons/18-volume-off.svg" />}  
        </div>
        <div className="signature">made by dallin.</div>    
    </div> : <></>
}